import React from "react";
import { BookOpenIcon, CalendarDaysIcon, ImageIcon, MapIcon, MusicIcon, WavesIcon, BoxIcon } from "lucide-react";
import { volumes, VolumeIcon } from "../data/content";
const iconMap: Record<VolumeIcon, BoxIcon> = {
  rhythm: MusicIcon,
  fretboard: WavesIcon,
  expression: BookOpenIcon,
  styles: MapIcon,
  cards: ImageIcon,
  planner: CalendarDaysIcon
};
export function Volumes() {
  return <section aria-labelledby="volumes-heading" className="bg-white" data-id="element-216" data-mp="1zujizrorln4h">
      <div className="mx-auto max-w-page px-4 py-12 sm:px-5 lg:py-24" data-id="element-217" data-mp="1zt8fzu358jef">
        <div className="max-w-2xl" data-id="element-218" data-mp="24tmdwjb16cyq">
          <p className="font-display text-xs font-bold uppercase tracking-[0.26em] text-gold-deep" data-id="element-219" data-mp="1qud72a8psv7f">
            Product reveal
          </p>
          <h2 id="volumes-heading" className="mt-4 font-display text-3xl font-extrabold leading-[1.05] tracking-[-0.03em] text-navy sm:text-4xl" data-id="element-220" data-mp="1vsesh1tm56m2">
            What’s inside the six volumes
          </h2>
        </div>

        <ol className="mt-8 grid gap-4 sm:mt-12 sm:grid-cols-2 sm:gap-6 lg:grid-cols-3" data-id="element-221" data-mp="kfvr3fps4rc8">
          {volumes.map((volume, index) => {
          const Icon = iconMap[volume.icon];
          const isGold = index % 2 === 1;
          return <li key={volume.number} className="flex flex-col rounded-lg border border-slate-200 bg-white p-5 transition-[border-color,box-shadow] sm:p-7 duration-150 ease-smooth hover:border-gold hover:shadow-[0_10px_30px_-18px_rgba(10,26,47,0.35)]" data-id="element-222" data-mp="3jbg9tyrtxerx" data-mpi={index}>
                <div className="flex items-center gap-4" data-id="element-223" data-mp="b0lg3oyrif2g">
                  <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md ${isGold ? 'bg-gold text-navy' : 'bg-navy text-gold'}`} data-id="element-224" data-mp="62jyl8gzint3">
                    <Icon className="h-5 w-5" aria-hidden="true" strokeWidth={2.25} data-id="element-225" data-mp="kqwvq8rt6cp6" />
                  </span>
                  <span className="font-display text-xs font-extrabold uppercase tracking-[0.18em] text-gold-deep" data-id="element-226" data-mp="ft4zx3o1m6fp">
                    Volume {volume.number}
                  </span>
                </div>

                <h3 className="mt-5 font-display text-lg font-extrabold leading-tight tracking-[-0.02em] text-navy sm:mt-6 sm:text-xl" data-id="element-227" data-mp="pog8t5crsjfj">
                  {volume.title}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-slate-500" data-id="element-228" data-mp="11t3olfn7g3zq">
                  {volume.description}
                </p>

                <p className="mt-auto pt-5 font-display text-[13px] font-bold text-navy-800 sm:pt-8" data-id="element-229" data-mp="1bidk75h9c4sl">
                  {volume.tags.join(' · ')}
                </p>
              </li>;
        })}
        </ol>
      </div>
    </section>;
}